
import { getToken } from '@/utils/cookies'

export interface DataAnalysisState{
  screenfull: boolean,
  screenTheme:string
}


export const state: DataAnalysisState = {
  screenfull: false,
  screenTheme:''
}
